.ftpOffer { display: flex; align-items: center; flex-wrap: wrap; gap: 12px; padding: 12px 24px; background: var(--paper-2); border-bottom: var(--border-hair); }
.values { flex: 1; min-width: 0; display: flex; align-items: center; gap: 8px; margin: 0; }
.label { font-family: var(--font-mono); font-size: 10px; letter-spacing: 1.2px; color: var(--text-secondary); }
.strava { font-family: var(--font-cond); font-size: 20px; font-weight: 900; }
.yours { font-family: var(--font-mono); font-size: 11px; letter-spacing: 0.6px; color: var(--text-secondary); }
.actions { display: flex; align-items: center; gap: 8px; }
/* Two classes: .btn loads after this module and would set 11px 16px. */
:global(.btn).action { padding: 9px 16px; }
.dismiss { padding: 9px 10px; font-family: var(--font-mono); font-size: 10px; letter-spacing: 1px; color: var(--text-secondary); }
.error { width: 100%; }
.reconnect { display: flex; align-items: center; flex-wrap: wrap; gap: 12px; padding: 12px 24px; border-bottom: var(--border-hair); }
.reconnectIcon { flex: none; color: var(--text-secondary); }
.reconnectText { flex: 1; margin: 0; font-size: 13px; line-height: 1.4; color: var(--text-secondary); }

.maxHr { width: 100%; display: flex; flex-direction: column; gap: 2px; padding: 10px 12px 12px; background: var(--paper-2); }
.maxHrHead { margin: 0; font-family: var(--font-mono); font-size: 10px; font-weight: 400; letter-spacing: 1.2px; }
.maxHrSub { margin: 0; font-family: var(--font-mono); font-size: 9px; letter-spacing: 0.6px; line-height: 1.5; color: var(--text-secondary); }
.steps { margin: 0; padding: 4px 0 6px; list-style: none; }
.step { display: flex; align-items: center; gap: 10px; min-height: 44px; border-bottom: var(--border-hair); cursor: pointer; }
.steps li:last-child .step { border-bottom: 0; }
.box { flex: none; display: inline-flex; align-items: center; justify-content: center; width: 16px; height: 16px; border: 1.5px solid var(--ink); background: var(--paper); color: var(--paper); }
.step[data-ticked='true'] .box { background: var(--ink); }
.step:has(input:focus-visible) .box { outline: 2px solid var(--hot); outline-offset: 2px; }
.stepMain { flex: 1; min-width: 0; display: flex; flex-direction: column; gap: 1px; }
.stepDate { font-family: var(--font-mono); font-size: 11px; }
.stepRide { overflow: hidden; font-family: var(--font-mono); font-size: 9px; letter-spacing: 0.6px; color: var(--text-secondary); text-overflow: ellipsis; white-space: nowrap; }
.stepValue { font-family: var(--font-cond); font-size: 18px; font-weight: 900; }
.step[data-ticked='false'] .stepDate, .step[data-ticked='false'] .stepValue { color: var(--text-secondary); }

@media (max-width: 639px) {
  .ftpOffer { flex-direction: column; align-items: stretch; gap: 10px; padding: 12px 16px; }
  .yours { font-size: 10px; }
  .actions > .action { flex: 1; }
  .dismiss { min-height: 44px; padding: 0 16px; }
  .reconnect { padding: 10px 16px; }
}

.sportOffer { display: flex; align-items: center; flex-wrap: wrap; gap: 8px 12px; padding: 12px 24px; background: var(--paper-2); border-bottom: var(--border-hair); }
.sportOffer[data-compact] { flex-direction: column; align-items: stretch; gap: 6px; padding: 10px 12px 12px; border-bottom: 0; }
.sportOffer[data-compact] .label { color: var(--ink); }
.why { flex-basis: 100%; order: 2; margin: 0; font-family: var(--font-mono); font-size: 9px; letter-spacing: 0.6px; line-height: 1.5; color: var(--text-secondary); }
.sportOffer .actions { order: 1; }
.sportOffer[data-compact] .actions { order: 3; padding-top: 4px; }

@media (max-width: 639px) {
  .sportOffer { flex-direction: column; align-items: stretch; gap: 10px; padding: 12px 16px; }
  .sportOffer .actions :global(.btn) { flex: 1; min-height: 44px; }
  .sportOffer .dismiss { min-height: 44px; padding: 0 16px; }
}
